export default "__VITE_ASSET__BGJCQkz2__"